import { Fragment } from 'react';
import { cn } from '@/lib/utils';

/**
 * Renders CMS text where *starred words* are highlighted in the brand orange, e.g.
 * "Design support for your *next move*." The asterisks never reach the page.
 */
export function Highlight({ text, className }: { text: string; className?: string }) {
  const parts = text.split(/\*([^*]+)\*/g);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <span key={i} className={cn('text-primary', className)}>
            {part}
          </span>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </>
  );
}

/** The same text without the markers — for aria-labels, titles and meta tags. */
export const plainText = (text: string) => text.replace(/\*([^*]+)\*/g, '$1');
